import React from 'react';
import { GetMemberProgramQuery } from 'src/graphqlTypes/catalogServiceTypes';
import {
	getDppFundingMetadata,
	getProgramFundingMetadata,
} from '@src/constants/programAttributeMapping';
import { isAffiliateProgram } from '@src/utilities/offeringHitsUtility';
import { getMemberPlanFundingLevel } from '@src/utilities/programAttributeUtility';
import { Highlight } from '../Highlight/Highlight';

interface Props {
	program: GetMemberProgramQuery['memberProgram'];
	loading: boolean;
}

export const FundingHighlight: React.FC<Props> = ({ program, loading }) => {
	if (!program.fundingLevel) return null;

	return (
		<>
			{isAffiliateProgram(program) ? (
				<Highlight
					body={getMemberPlanFundingLevel(program.fundingLevel)}
					dpp={true}
					label='Funding'
					loading={loading}
					popoverContent={getDppFundingMetadata(program.fundingLevel)}
				/>
			) : (
				<Highlight
					body={getMemberPlanFundingLevel(program.fundingLevel)}
					label='Funding'
					loading={loading}
					popoverContent={getProgramFundingMetadata(program.fundingLevel)}
				/>
			)}
		</>
	);
};
